$(document).on('click', '[data-cms-news-more]', function(event) {
  event.preventDefault();
  const paging = $(this).parent().addClass('invisible');
  const url = $(this).attr('data-cms-news-more');

  $.ajax({
    url: url || $(this).attr('href'),
    method: 'GET',
  }).then((resp) => {
    paging.replaceWith(resp);
  });
});
